import React from 'react';
import {
  Box, Button, Card, Grid, Typography, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './Page.module.css';

const faqs = [
  {
    question: <div>What Gluten-Free Crust Pizza Options Does Pizza Hut Have?</div>,
    answer: (
      <div>
        Pizza Hut has a create-your-own option with Udi&apos;s&reg; gluten-free crust. Most standard Pizza Hut toppings
        are naturally gluten-free, however, meatballs and Creamy Garlic Parmesan Sauce are excluded due to containing
        wheat.
      </div>
    )
  },
  {
    question: <div>Is Gluten-Free Crust offered in every Pizza Hut&reg; restaurant in the U.S.?</div>,
    answer: (
      <div>
        Pizzas that are made with Udi&apos;s&reg; Gluten-Free Crust are currently offered in about 1/3 of Pizza Hut&reg;
        restaurants nationwide. Please <a href="https://www.pizzahut.com/localize">Start Your Order</a> and enter your
        zip code or address for Delivery or Carryout and look for the Gluten-Free tab on the Pizza page.
      </div>
    )
  },
  {
    question: <div>What are the options for pizzas that are made with Gluten-Free Crust?</div>,
    answer: (
      <div>
        We offer a create-your-own option with Udi&apos;s Gluten-Free Crust. Most standard Pizza Hut toppings are
        naturally gluten-free, however, meatballs, Creamy Garlic Parmesan Sauce are excluded due to containing wheat.
      </div>
    )
  },
  {
    question: <div>How many people does a pizza made with Udi&apos;s Gluten-Free Crust feed?</div>,
    answer: (
      <div>
        The pizza made with Udi&apos;s Gluten-Free Crust is 10 inches and cut into 8 slices, which typically feeds 1-2
        people.
      </div>
    )
  },
  {
    question: <div>Do you use gluten-free dedicated kitchen utensils?</div>,
    answer: (
      <div>
        Pizza Hut uses a separate dedicated roller cutter to cut pizzas made with Udi&apos;s Gluten-Free Crust, which is
        cut in the box.
      </div>
    )
  },
  {
    question: <div>Do you have flour in your restaurant?</div>,
    answer: (
      <div>
        We do not have loose, or airborne, flour in our restaurants where Udi&apos;s Gluten-Free Crust is on the menu.
        However, we do have offerings on our menu that contain gluten.
      </div>
    )
  },
  {
    question: <div>Are pizzas made with Gluten-Free Crust packaged in designated Gluten-Free Crust boxes?</div>,
    answer: (
      <div>
        Yes, we have designated pizza boxes, featuring Udi&apos;s&reg;. Your pizza made with Udi&apos;s Gluten-Free
        Crust should always be delivered in this designated labeled box.
      </div>
    )
  },
  {
    question: <div>Do you have any other gluten-free items on your menu?</div>,
    answer: (
      <div>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://m.nutritionix.com/pizza-hut/menu/special-diets/premium/"
        >
          Click here
        </a>{' '}
        for a list of menu items that do not contain wheat or gluten.
      </div>
    )
  },
  {
    question: <div>What are the ingredients of our Gluten-Free Crust?</div>,
    answer: (
      <div>
        Udi&apos;s&reg; Gluten-Free Crust includes the following ingredients: Water, Tapioca Starch, Brown Rice Flour,
        Canola Oil, Egg Whites, Dried Cane Syrup, Tapioca Syrup, Tapioca Maltodextrin, Salt, Xanthan Gum, Yeast,
        Cultured Corn Syrup Solids And Citric Acid (Mold Inhibitor), Enzymes.
      </div>
    )
  },
  {
    question: (
      <div>
        Are there any other &lsquo;Big 8&rsquo; allergens in pizzas that are made with Udi&apos;s Gluten-Free Crust?
      </div>
    ),
    answer: (
      <div>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://m.nutritionix.com/pizza-hut/menu/special-diets/premium/"
        >
          Click Here
        </a>{' '}
        for allergen information about the Udi&apos;s&reg; Gluten-Free Crust and Pizza Hut&reg; ingredients.
      </div>
    )
  },
  {
    question: <div>Do any other pizza ingredients at Pizza Hut&reg; contain gluten?</div>,
    answer: (
      <div>
        Pizza Hut&apos;s&reg; Creamy Garlic Parmesan pizza sauce and classic meatball topping contain gluten.{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://m.nutritionix.com/pizza-hut/menu/special-diets/premium/"
        >
          Click Here
        </a>{' '}
        for a list of menu items that do not contain wheat or gluten.
      </div>
    )
  },
  {
    question: (
      <div>What are the nutritionals (calories, fat, etc.) for pizzas that are made with our Gluten-Free Crust?</div>
    ),
    answer: (
      <div>
        <a target="_blank" rel="noopener noreferrer" href="https://m.nutritionix.com/pizza-hut/portal/">
          Click Here
        </a>{' '}
        to view the pizzas that are made with Udi&apos;s Gluten-Free Crust nutritional facts.
      </div>
    )
  },
  {
    question: (
      <div>
        If I have Celiac Disease is it safe for me to eat a pizza made with our Gluten-Free Crust from Pizza Hut&reg;?
      </div>
    ),
    answer: (
      <div>
        While Pizza Hut is proud to offer pizzas that are made with Udi&apos;s Gluten-Free Crust, Pizza Hut kitchens are
        not gluten-free environments. Due to the handcrafted nature of our menu items, variations in vendor-supplied
        ingredients, and our use of shared cooking, storage and preparation areas, we cannot assure you that our
        restaurant environment or any menu item will be free of gluten. Select ingredients do contain gluten, please
        refer to the online allergen tool at pizzahut.com/nutrition for more information. We recommend that you consult
        your medical advisor as to what is safe for you.
      </div>
    )
  }
];

const GlutenFree = (): JSX.Element => (
  <>
    <Grid container spacing={3} style={{ marginBottom: '3rem' }} className={styles.headerContainer}>
      <Grid item xs={12} lg={8} className={styles.headerGrid}>
        <Typography variant="h1">Looking for Gluten Free Pizza Near You?</Typography>
      </Grid>
      <Grid item xs={12} lg={8} className={styles.headerGrid}>
        <Typography variant="body2" style={{ marginBottom: '4rem' }}>
          Pizza Hut&apos;s Pizzas that are made with Udi&apos;s&reg; Gluten-Free Crust are currently offered in certain
          participating Pizza Hut&reg; restaurants nationwide. To order a Pizza Hut Gluten Free pizza click &quot;Start
          Your Order&quot; below, pick your pizza of choice, and select the Gluten-Free option.
        </Typography>

        <Card className={styles.orderCard}>
          <div className={styles.orderCardContent}>
            <Typography variant="h2" style={{ marginTop: '0', marginBottom: '2rem' }}>
              Order Gluten Free Crust Pizza Today!
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.location.href = 'https://pizzahut.com/localize';
              }}
              style={{ paddingLeft: '8rem', paddingRight: '8rem' }}
            >
              Start Your Order
            </Button>
          </div>
          <img alt="Pizza Hut Map Marker" src="/images/glutenFree/ph-marker.png" className={styles.orderCardIcon} />
        </Card>
      </Grid>
      <Grid item xs={12} lg={4} className={styles.contentSection}>
        {/* Pizza Image */}
        <div className={styles.imageContainer} />
      </Grid>
    </Grid>

    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Box>
          <Typography variant="h2" style={{ marginBottom: '2rem' }}>
            Frequently Asked Questions
          </Typography>
          <div className="accordion-faq" role="tablist" aria-multiselectable="true">
            {faqs.map((faq, index) => (
              <Accordion key={index} className={styles.accordion} style={{ boxShadow: 'none' }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${index}a-content`}
                  id={`panel${index}a-header`}
                  className={styles.accordionSummary}
                  style={{ fontWeight: 'bold', padding: '1.5rem 0' }}
                >
                  {faq.question}
                </AccordionSummary>
                <AccordionDetails className={styles.accordionAnswer} style={{ paddingBottom: '5rem' }}>
                  {faq.answer}
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </Box>
      </Grid>
    </Grid>
  </>
);

export default GlutenFree;
